import { useRef } from 'react'
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider'
import { Handle, Track, Tick } from './SelectSliderElements'
import { SelectRailStyle } from './StyledElements'

const SelectSlider = ({
  handleSliderChange,
  handleSliderUpdate,
  timeDomain,
  handlesValues,
  index,
  chart,
}) => {
  const selectSliderStyle = {
    position: 'relative',
    // width: chart.current ? chart.current.chart.plotWidth + 0 + 'px' : '1000px',
    width: chart.current
      ? Math.round(
          chart.current.chart.series[0].data[
            chart.current.chart.series[0].data.length - 1
          ].plotX - chart.current.chart.series[0].data[0].plotX
        ) + 'px'
      : '1000px',
    height: 20,
  }
  const val = useRef([])
  const onSliderChange = (values) => {
    handleSliderChange(values, index)
  }
  const onSliderUpdate = (values, index) => {
    if (val.current.length > 0) {
      const temp =
        values[0] !== val.current[0]
          ? values[0]
          : values[1] !== val.current[1]
          ? values[1]
          : -1
      if (temp !== -1) {
        /* console.log('slider : ' + temp) */
        handleSliderUpdate(temp)
      }
    }
    val.current = values
  }

  return (
    <>
      <Slider
        rootStyle={selectSliderStyle}
        vertical={false}
        mode={1}
        domain={timeDomain}
        step={1}
        values={handlesValues}
        onChange={onSliderChange}
        onUpdate={onSliderUpdate}
      >
        <Rail>
          {({ getRailProps }) => (
            <div style={SelectRailStyle} {...getRailProps()} />
          )}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="move-slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="move-slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                  index={index}
                />
              ))}
            </div>
          )}
        </Tracks>
      </Slider>
    </>
  )
}

export default SelectSlider
